// Should stay in sync with classificationCalculationType.mjs

export const CLASSIFICATION_CALCULATION_TYPE = {
  TOTAL: 1,
  PERCENTAGE: 2
};
